export default "__VITE_ASSET__dh09x6pf3caCnYAo_0idfw__"